import * as Yup from 'yup';

import { contactsValidationSchema } from 'src/common/validation/contact';
import type { IContactWithReferenceCount } from 'src/types/IContactWithReferenceCount';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export type IVendorProductLeadContactTabFormValues = {
  contacts: IContactWithReferenceCount[];
};

export const vendorProductLeadContactTabValidationSchema = Yup.object<IVendorProductLeadContactTabFormValues>().shape({
  contacts: contactsValidationSchema,
});

export function toVendorLeadContactTabInitialValues(
  vendorProductLead: IVendorLeadProduct
): IVendorProductLeadContactTabFormValues {
  return {
    contacts: vendorProductLead.contacts,
  };
}
